export type BetslipParentTheme = {
  btnBackground?: string;
  btnColor?: string;
  badgeBackground?: string;
  badgeColor?: string;
};

const pickCssVar = (style: CSSStyleDeclaration, names: string[]): string => {
  for (const name of names) {
    const value = style.getPropertyValue(name).trim();
    if (value) {
      return value;
    }
  }
  return "";
};

export const getBetslipParentTheme = (): BetslipParentTheme => {
  const style = getComputedStyle(document.documentElement);

  return {
    btnBackground: pickCssVar(style, [
      "--background-header-betslip-mobile",
      "--background-header-betslip",
      "--background-betslip-button",
    ]),
    btnColor: pickCssVar(style, [
      "--color-text-3",
      "--color-text-nav-betslip",
      "--color-text",
    ]),
    badgeBackground: pickCssVar(style, [
      "--background-primany",
      "--background-tab--active",
      "--color-icon-common",
    ]),
    badgeColor: pickCssVar(style, [
      "--color-text-2",
      "--color-text-nav-betslip-active",
      "--color-text",
    ]),
  };
};

export const notifyParentBetslipTheme = (): void => {
  if (window.parent === window) {
    return;
  }

  window.parent.postMessage(
    { type: "betslip-theme", data: getBetslipParentTheme() },
    "*"
  );
};
